import React, { Component } from 'react';

import './CommaSeparateEmail.css';

export class CommaSeparateChip extends Component {

    constructor(props) {
        super(props)
        this.state = {
            emailList: [],
            width: '40%',
            inputval: '',
            validationMessage: ''
        }

        this.inputElement = React.createRef();
    }

    componentDidUpdate(prevProp, prevState) {
        if (prevState.emailList !== this.state.emailList) {
            if (this.state.emailList.length === 0 && this.inputElement.length !== 0) {
                this.props.changeErrorMessage('Separate Email with a comma or press Enter')
            }
            this.props.commaSeparetedFunc(this.state.emailList)
        }
    }

    removeChipFunc = (e, email) => {
        e.stopPropagation();
        const emailList = this.state.emailList.filter(val => {
            return val != email
        })
        this.setState({
            emailList
        })
    }

    clickParent = (e) => {
        e.stopPropagation();
        this.inputElement.focus()
    }

    editChipFunc = (e, email) => {
        e.stopPropagation();
        const emailList = this.state.emailList.filter(val => {
            return val != email
        })

        this.setState({
            emailList
        }, () => {
            this.inputElement.value = email
        })
    }

    changedInput = (e) => {

        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


        if (e.keyCode === 188 || e.keyCode === 13) {
            const value = e.keyCode === 188 ? e.target.value.substring(0, e.target.value.length - 1).replace(/\s/g, '') : e.target.value.replace(/\s/g, '');

            const emailList = [...this.state.emailList];


            if (!emailList.includes(value) && regexEmail.test(value)) {
                emailList.push(value)
                this.inputElement.value = ''
                this.setState({
                    validationMessage: '',
                    emailList
                })
            } else {
                if (emailList.includes(value)) {
                    this.setState({
                        validationMessage: `${value} already exists`
                    })
                } else {
                    this.setState({
                        validationMessage: `${value} is not valid`
                    })
                }
                this.inputElement.value = value
            }
        }

    }

    focusOut = () => {

    }

    render() {
        return (
            <div>
                <div style={{ border: 'solid 1px #afaeae' }} onClick={(e) => this.clickParent(e)}>
                    {
                        this.state.emailList.map(val => (
                            <CommaSeparateEmail email={val} editFunc={(e) => this.editChipFunc(e, val)} removeFunc={(e) => this.removeChipFunc(e, val)} />
                        ))
                    }
                    <div className="textarea-parent">
                        <input onBlur={() => this.focusOut()} onKeyUp={(e) => this.changedInput(e)} style={{ minWidth: this.state.width }} ref={input => this.inputElement = input} className="inputNameComma" />
                    </div>
                </div>
                <p className="error-message-commaseparate">{this.state.validationMessage}</p>
            </div>
        )
    }
}

export const CommaSeparateEmail = ({ email, removeFunc, editFunc }) => {
    return (
        <div style={{ padding: 2, display: 'inline-block', maxWidth: '100%' }} onClick={editFunc}>
            <div className="chip">
                <div className="chip-content">{email}</div>
                <div className="chip-close" onClick={removeFunc}>
                    <svg className="chip-svg" focusable="false" viewBox="0 0 33 29" aria-hidden="true">
                        <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path>
                    </svg>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/_components/common/Form2/CommaSeparateEmail.jsx